<app-admin-stock-list />
